import { FC, ReactNode } from 'react';

import { FlexWrapper } from './Flex.styled';

interface FlexWrapperProps {
  display?: 'flex' | 'inline-flex';
  itemAlign?: 'stretch' | 'flex-start' | 'flex-end' | 'center' | 'baseline';
  justifyContent?:
    | 'flex-start'
    | 'flex-end'
    | 'center'
    | 'space-between'
    | 'space-around'
    | 'space-evenly'
    | 'normal';
  direction?: 'row' | 'column';
  gap?: string;
  flexWrap?: 'nowrap' | 'wrap' | 'wrap-reverse';
  children: ReactNode;
  margin?: string;
  contain?: boolean;
  flex?: string;
  padding?: string;
  background?: string;
  borderRadius?: string;
  maxWidth?: string;
  height?: string;
  fullHeight?:boolean;
}

export const Flex: FC<FlexWrapperProps> = ({
  children,
  display,
  itemAlign,
  justifyContent,
  direction,
  gap,
  flexWrap,
  margin,
  contain,
  flex,
  padding,
  background,
  borderRadius,
  maxWidth,
  height,
  fullHeight,
}) => (
  <FlexWrapper
    display={display}
    itemalign={itemAlign}
    justifycontent={justifyContent}
    direction={direction}
    gap={gap}
    margin={margin}
    flexwrap={flexWrap}
    contain={contain}
    flex={flex}
    padding={padding}
    background={background}
    borderRadius={borderRadius}
    maxWidth={maxWidth}
    height={height}
    fullHeight={fullHeight}
  >
    {children}
  </FlexWrapper>
);
